import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from './i18n'
import 'vue-select/src/scss/vue-select.scss';
import './assets/css/global.scss'
import './assets/css/tooltip.scss'
import "ant-design-vue/dist/antd.css";
import cssVars from 'css-vars-ponyfill';
import GLOBAL_MIXIN from './globalMixin.js'
import Antd from "ant-design-vue";

Vue.config.productionTip = false

Vue.mixin(GLOBAL_MIXIN);

// Import Loader
import Loader from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
Vue.use(Loader)


// Import Linkify
import linkify from 'vue-linkify'
Vue.directive('linkified', linkify)

// import croppie for image cropping
import VueCroppie from 'vue-croppie';
import 'croppie/croppie.css'
Vue.use(VueCroppie);

import VTooltip from 'v-tooltip'
Vue.use(VTooltip, {
    defaultClass: 'v_tooltip'
})

// ANT design
Vue.use(Antd);

// Import assets
import images from './js/images'
Vue.prototype.$images = images

// enables css variables on safari 6+ and ie11
cssVars({
    rootElement   : document,
    shadowDOM     : false,

    // Sources
    include       : 'link[rel=stylesheet],style',
    exclude       : '',
    variables     : {},

    // Options
    onlyLegacy    : true,
    preserveStatic: true,
    preserveVars  : false,
    silent        : false,
    updateDOM     : true,
    updateURLs    : true,
    watch         : true,
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')


